import { useState } from "react";
import { useEditorStore } from "@/store/editorStore";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Monitor, Tablet, Smartphone } from "lucide-react";
import ElementRenderer from "./ElementRenderer";

const DEVICES = {
  desktop: { label: "Desktop", icon: Monitor, width: 1024, height: 640, scale: 0.7 },
  tablet: { label: "Tablet", icon: Tablet, width: 768, height: 1024, scale: 0.5 },
  mobile: { label: "Mobile", icon: Smartphone, width: 390, height: 720, scale: 0.7 },
};

export default function DevicePreview({ open, onClose }) {
  const pages = useEditorStore((s) => s.pages);
  const [device, setDevice] = useState("desktop");
  const d = DEVICES[device];

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-5xl h-[85vh] flex flex-col" data-testid="device-preview-modal">
        <DialogHeader>
          <DialogTitle className="font-display tracking-tight">Responsive preview</DialogTitle>
        </DialogHeader>

        <div className="flex items-center justify-center gap-2 my-3">
          {Object.entries(DEVICES).map(([k, v]) => {
            const Icon = v.icon;
            return (
              <button
                key={k}
                onClick={() => setDevice(k)}
                className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm ${
                  device === k ? "bg-[#002FA7] text-white" : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                }`}
                data-testid={`device-${k}`}
              >
                <Icon className="w-4 h-4" /> {v.label}
              </button>
            );
          })}
        </div>

        <div className="flex-1 overflow-auto ch-scroll bg-gray-100 rounded p-6 flex flex-col items-center gap-6">
          {pages.map((p) => (
            <div
              key={p.id}
              className="bg-white shadow-lg border border-gray-200 relative overflow-hidden"
              style={{
                width: d.width * d.scale,
                height: d.height * d.scale,
                background: p.backgroundImage
                  ? `url(${p.backgroundImage}) center/cover no-repeat`
                  : p.background || "#FFFFFF",
              }}
            >
              <div
                style={{
                  width: 1024,
                  height: 768,
                  transform: `scale(${Math.min((d.width * d.scale) / 1024, (d.height * d.scale) / 768)})`,
                  transformOrigin: "top left",
                  position: "relative",
                }}
              >
                {p.elements.map((el) => (
                  <ElementRenderer key={el.id} element={el} preview />
                ))}
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
